import React, { useState, useEffect, useRef } from "react";
import "./orderView.scss";
import { Link } from "react-router-dom";
import axios from "axios";
import { dateFormat } from "../../utils/dateFormat";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const OrderView = ({ orderId }) => {
  const [order, setOrder] = useState({});
  const pdfRef = useRef(); // reference for capturing content

  useEffect(() => {
    if (!orderId) return;

    const getSingaleOrder = async () => {
      try {
        const response = await axios.get(`/get-singal-order/${orderId}`);
        setOrder(response.data);
      } catch (error) {
        console.error("Error fetching order", error);
      }
    };
    getSingaleOrder();
  }, [orderId]);

  // Function to download PDF
  const downloadPDF = () => {
    const input = pdfRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 190; // A4 width in mm
      const pageHeight = 295; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 10;

      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add extra pages if needed
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`Order_${order.orderId}.pdf`);
    });
  };

  return (
    <div className="addPro_in">
      <div className="addNew_wrap">
        <div>
          <div className="pro_head">
            <h2>Order summary</h2>
            <div className="orderWrp">
              <button onClick={downloadPDF} className="download-btn">
                Download PDF
              </button>
            </div>
          </div>
          <br />
          <div ref={pdfRef}>
            <div className="product_info_wrap">
              <div>
                <div className="product_pro">
                  <div className="customer">
                    <div className="customer_in">
                      <h4>Shipping Details</h4>
                    </div>
                    <div className="customer_in">
                      <p>
                        {order.fullName} <br />
                        {order.address} <br />
                        {order.homeName}
                        {order.landmark} <br />
                        {order.city} <br />
                        {order.phone} <br />
                        {order.email} <br />
                      </p>
                    </div>
                  </div>
                  <div className="customer_ad">
                    <div className="customer_in">
                      <h4>Order Details</h4>
                    </div>
                    <div className="customer_in">
                      <ul>
                        <li>
                          <em>OrderId :</em> {order.orderId}
                        </li>
                        <li>
                          <em>Brand :</em> {order.brand}
                        </li>
                        <li
                          style={{
                            color:
                              order.paymentStatus === "Paid"
                                ? "rgb(92, 184, 92)"
                                : "red",
                          }}
                        >
                          <em>Payment Status :</em> {order.paymentStatus}
                        </li>
                        <li>
                          <em>Payment Method : </em>
                          {order.paymentMethod}
                        </li>
                        <li>
                          <em>Order Date :</em> {dateFormat(order.createdAt)}{" "}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <table>
                    <thead>
                      <tr>
                        <th></th>
                        <th>ITEMS</th>
                        <th>WEIGHT </th>
                        <th>QTY</th>
                        <th>FLASH</th>
                        <th>REG</th>
                        <th>AMOUNT</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order.products?.map((item, i) => (
                        <tr key={i}>
                          <th>{i + 1}</th>
                          <td>
                            {item.name} {item.lrCode}{" "}
                          </td>
                          <td>{item.weight}</td>
                          <td>{item.quantity}</td>
                          <td>{item.flashPrice}</td>
                          <td>{item.price}</td>
                          <td>
                            {item.flashPrice && item.flashPrice > 0
                              ? item.flashPrice * item.quantity
                              : item.price * item.quantity}{" "}
                            AED
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <th></th>
                        <td>Shipping (Free Delivery)</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{order.deliveryCost}</td>
                      </tr>
                      <tr>
                        <th>Total</th>
                        <td></td>
                        <td></td>
                        <td>{order.num_pieces}</td>
                        <td></td>
                        <td></td>
                        <th>{order.totalAmount} AED</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Link to={"/orders"}>
          <div className="_close"></div>
        </Link>
      </div>
    </div>
  );
};

export default OrderView;
